import { queryOptions } from '@tanstack/react-query';
import { getContentStrategy } from 'src/common/Scraper';
import {
  ContentStrategyApiResponseV2,
  ContentStrategyPaginationParamsV2
} from '../../types/content-strategy-v2.type';

function getContentStrategyQuery(
  userId: string,
  siteId: string,
  pagination?: ContentStrategyPaginationParamsV2
) {
  return queryOptions({
    queryKey: ['content-strategy', userId, siteId, pagination],
    queryFn: () =>
      getContentStrategy(
        userId,
        siteId,
        pagination
      ) as Promise<ContentStrategyApiResponseV2>,
    enabled: !!siteId && !!userId
  });
}

export default getContentStrategyQuery;
